import { render, staticRenderFns } from "./ApplicationRecord.vue?vue&type=template&id=066e8146&scoped=true"
import script from "./ApplicationRecord.vue?vue&type=script&lang=js"
export * from "./ApplicationRecord.vue?vue&type=script&lang=js"
import style0 from "./ApplicationRecord.vue?vue&type=style&index=0&id=066e8146&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "066e8146",
  null
  
)

export default component.exports